
const ServiceAreas = () => {
  const lisbonAreas = [
    'Amadora', 'Loures', 'Odivelas', 'Benfica', 'Algés', 'Oeiras', 'Cacém', 'Sintra', 'Cascais', 
    'Belém', 'Restelo', 'Ajuda', 'Alcântara', 'Santos', 'Príncipe Real',
    'Marquês de Pombal', 'Avenidas Novas', 'Alvalade', 'Lumiar', 'Olivais'
  ];

  const margemSulAreas = [
    'Almada', 'Seixal', 'Barreiro', 'Moita', 'Setúbal', 'Montijo', 'Alcochete',
    'Corroios', 'Pragal', 'Cacilhas', 'Trafaria', 'Costa da Caparica',
    'Charneca de Caparica', 'Sobreda', 'Fernão Ferro', 'Sesimbra'
  ];

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
            Zonas Atendidas
          </h2>
          <p className="text-base text-gray-700">
            Lisboa e Margem Sul com técnicos locais
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Lisboa */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Lisboa</h3>
            <div className="flex flex-wrap gap-2">
              {lisbonAreas.map((area, index) => (
                <span key={index} className="px-3 py-1 bg-white border border-gray-200 rounded-full text-sm text-gray-700">
                  {area}
                </span>
              ))}
            </div>
          </div>

          {/* Margem Sul */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Margem Sul</h3>
            <div className="flex flex-wrap gap-2">
              {margemSulAreas.map((area, index) => (
                <span key={index} className="px-3 py-1 bg-white border border-gray-200 rounded-full text-sm text-gray-700">
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
